import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import MovieServices from '../../services/externalServices/TicketServices/moviesServices';
import BookingBreadcrumb from "../components/BookingBreadcrumb";
import { FiArchive, FiEdit, FiTrash2, FiPlus, FiFilm } from 'react-icons/fi';


function MovieBooking() {
    const navigate = useNavigate();
    const [movies, setMovies] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteMovieId, setDeleteMovieId] = useState(null);
    const [statusMessage, setStatusMessage] = useState(null);
    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));


    // useEffect(() => {
    //     const fetchMovies = async () => {
    //         const movies = await MovieServices.getMovies();
    //         setMovies(movies);
    //     };
    //     fetchMovies();
    // }, []);



    useEffect(() => {
        if (statusMessage) {
            const timer = setTimeout(() => {
                setStatusMessage(null);
            }, 5000); // 5 seconds
            return () => clearTimeout(timer);
        }
    }, [statusMessage]);


    useEffect(() => {
        const fetchMovies = async () => {
            try {
                // Pass theatreName only if the user is a ticket-admin
                const isTicketAdmin = role === 'ticket-admin';
                console.log('isTicketAdmin', isTicketAdmin);
                const theatreName = accessList?.[0]; // assuming accessList contains theatre name

                // const cleanTheatreName = (theatreName || '').replace(/\?$/, '').trim();

                const movies = await MovieServices.getMovies(isTicketAdmin ? theatreName : '');
                // const movies = await MovieServices.getMoviesReadyToBook(isTicketAdmin ? theatreName : '');

                console.log('movies in the table', movies);
                setMovies(movies);
            } catch (err) {
                console.error("Error fetching movies:", err);
            }
        };
        fetchMovies();
    }, []);


    const AddMovies = () => {
        navigate('/addMovies')
    }


    // const handleView = (movie) => navigate(`/movieDetails/${movie._id}`, { state: { movie } });
    // const handleEdit = (movie) => console.log("Edit", movie);
    const handleEdit = (movie) => {
        navigate('/editMovies', { state: { movie } });
    };
    // const handleDelete = (id) => console.log("Delete", id);



    // const handleDelete = async (id) => {
    //     const confirm = window.confirm("Are you sure you want to delete this movie?");
    //     if (!confirm) return;

    //     try {
    //       await MovieServices.deleteMovie(id);
    //       alert("Movie deleted successfully!");
    //       // Optionally refresh movie list
    //       setMovies((prev) => prev.filter((m) => m._id !== id));
    //     } catch (error) {
    //       console.error("Failed to delete movie", error);
    //       alert("Failed to delete movie");
    //     }
    //   };



    const confirmDeleteMovie = async () => {
        try {
            const response = await MovieServices.deleteMovie(deleteMovieId);
            const message = response?.message || '';
            setStatusMessage({ type: 'success', text: message });

            if (message === 'Movie deleted successfully') {
                setMovies((prev) => prev.filter((m) => m._id !== deleteMovieId));
            }
        } catch (error) {
            const errorMsg = error?.response?.message || 'Failed to delete movie.';
            setStatusMessage({ type: 'error', text: errorMsg });
        } finally {
            setShowDeleteModal(false);
            setDeleteMovieId(null);
        }
    };

    const handleDelete = (id) => {
        setDeleteMovieId(id);
        setShowDeleteModal(true);
    };


    const handleArchive = async (id) => {
        const confirm = window.confirm("Are you sure you want to archive this movie?");
        if (!confirm) return;

        try {
            const response = await MovieServices.updateMovie(id, { isArchived: true });
            alert("✅ Movie archived successfully!");
            setMovies((prev) => prev.filter((m) => m._id !== id)); // Optionally remove from list
        } catch (err) {
            console.error("Failed to archive movie", err);
            alert("❌ Failed to archive movie.");
        }
    };






    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-purple-50 pb-12">
            <div className="container mx-auto px-4 py-8">
                <BookingBreadcrumb currentStep="moviebooking" showBack={false} />
                {/* <div className="flex items-center justify-between mb-12">
                    <h1 className="text-3xl font-bold text-gray-900">Movie Management</h1>
                    <button
                        onClick={AddMovies}
                        className="flex items-center gap-2 bg-black hover:bg-gray-700 text-white px-4 py-2  transition-all shadow-md hover:scale-105"
                    >
                        <FiPlus className="text-lg" />
                        <span>Add Movie</span>
                    </button>
                </div> */}

                {/* Status Message */}
                {statusMessage && (
                    //     <div className={`fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-xl z-50 
                    // ${statusMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    //         {statusMessage.text}
                    //     </div>


                    <div className={`fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-xl z-[9999] 
${statusMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {statusMessage.text}
                    </div>
                )}



                {/* Delete Modal */}
                {showDeleteModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-xl p-6 w-96 shadow-lg text-center">
                            <h2 className="text-xl font-semibold text-gray-900">Are you sure?</h2>
                            <p className="text-gray-600 mt-2">This action cannot be undone.</p>
                            <div className="flex justify-center gap-4 mt-6">
                                <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300">Cancel</button>
                                <button onClick={confirmDeleteMovie} className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700">Confirm</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Movie Cards */}
                {/* {movies.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.map((movie) => (
                            <div key={movie._id} className="flex flex-col h-full bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-lg transition-shadow duration-300">
                              
                                <div className="relative h-64 w-full overflow-hidden">
                                    {movie.isReadyForBooking ? (
                                        <Link to={`/movieDetails/${movie._id}`} state={{ movie }}>
                                            <img
                                                src={movie.imageUrl}
                                                alt={movie.name}
                                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                                            />
                                        </Link>
                                    ) : (
                                        <>
                                            <img
                                                src={movie.imageUrl}
                                                alt={movie.name}
                                                className="w-full h-full object-cover"
                                            />
                                            <div className="absolute top-2 -right-3 bg-[#dd0426] text-xs font-bold text-white px-3 py-1 rounded-full shadow-md">
                                                Coming Soon
                                            </div>
                                        </>
                                    )}
                                    <div className="absolute bottom-0 w-full p-4 bg-gradient-to-t from-black/80 to-transparent text-white">
                                        <h3 className="text-xl font-semibold truncate">{movie.name}</h3>
                                        <div className="flex items-center justify-between text-sm mt-1">
                                            <span>{movie.duration} mins</span>
                                            <div className="flex items-center gap-1">
                                                <span className="text-yellow-400">★</span>
                                                <span>{movie.imdbRating}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                             
                                <div className="flex-grow p-4">
                                    <div className="flex flex-wrap gap-2">
                                        {movie.movieLanguages.map((lang, i) => (
                                            <span key={i} className="px-2 py-1 bg-blue-100 text-gray-800 text-xs rounded-full font-medium">
                                                {lang}
                                            </span>
                                        ))}
                                    </div>
                                </div>

                              
                                <div className="p-2 border-t border-gray-200 bg-white">
                                    {movie.isReadyForBooking && (
                                        <div className="flex justify-center">
                                            <button
                                                onClick={() => navigate(`/movieDetails/${movie._id}`, { state: { movie } })}
                                               
                                                className="bg-red-500 text-white border border-red-500 text-sm text-base rounded-lg px-3 py-2 hover:bg-red-500 transition duration-200"
                                            >
                                                Book Now
                                            </button>
                                        </div>
                                    )}
                                </div>


                              
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center h-96">
                        <FiFilm className="text-6xl text-gray-500 mb-4" />
                        <p className="text-2xl text-gray-400 font-medium">No movies found</p>
                        <p className="text-gray-500 mt-2">Start by adding a new movie</p>
                    </div>
                )} */}











                {movies.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.map((movie) => (
                            <div key={movie._id} className="flex flex-col h-full bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-lg transition-shadow duration-300">
                                {/* Movie Image */}
                                <div className="relative h-64 w-full overflow-hidden">
                                    {/* ✅ Make ALL movies clickable for admin access */}
                                    <Link to={`/movieDetails/${movie._id}`} state={{ movie }}>
                                        <img
                                            src={movie.imageUrl}
                                            alt={movie.name}
                                            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                                        />
                                    </Link>

                                    {/* ✅ Update status indicator */}
                                    {!movie.isReadyForBooking && (
                                        <div className="absolute top-2 -right-3 bg-orange-500 text-xs font-bold text-white px-3 py-1 rounded-full shadow-md">
                                            Not Ready
                                        </div>
                                    )}

                                    <div className="absolute bottom-0 w-full p-4 bg-gradient-to-t from-black/80 to-transparent text-white">
                                        <h3 className="text-xl font-semibold truncate">{movie.name}</h3>
                                        <div className="flex items-center justify-between text-sm mt-1">
                                            <span>{movie.duration} mins</span>
                                            <div className="flex items-center gap-1">
                                                <span className="text-yellow-400">★</span>
                                                <span>{movie.imdbRating}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Movie Details - This will grow to fill space */}
                                <div className="flex-grow p-4">
                                    <div className="flex flex-wrap gap-2">
                                        {movie.movieLanguages.map((lang, i) => (
                                            <span key={i} className="px-2 py-1 bg-blue-100 text-gray-800 text-xs rounded-full font-medium">
                                                {lang}
                                            </span>
                                        ))}
                                    </div>
                                </div>

                                {/* ✅ Updated Button - Show for ALL movies */}
                                <div className="p-2 border-t border-gray-200 bg-white">
                                    <div className="flex justify-center">
                                        <button
                                            onClick={() => navigate(`/movieDetails/${movie._id}`, { state: { movie } })}
                                            className={`px-3 py-2 text-sm font-semibold rounded-lg shadow-md transition duration-200 ${movie.isReadyForBooking
                                                    ? "bg-red-500 text-white border border-red-500 hover:bg-red-600"
                                                    : "bg-orange-500 text-white border border-orange-500 hover:bg-orange-600"
                                                }`}
                                        >
                                            {movie.isReadyForBooking ? "Book Now" : "Admin Preview"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center h-96">
                        <FiFilm className="text-6xl text-gray-500 mb-4" />
                        <p className="text-2xl text-gray-400 font-medium">No movies found</p>
                        <p className="text-gray-500 mt-2">Only archived movies are hidden from admin view</p>
                    </div>
                )}

            </div>
        </div>
    );
}

export default MovieBooking
